import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { Grid, H, Image, P } from '@farewill/ui'
import { FONT } from '@farewill/ui/tokens'
import { screenMax } from '@farewill/ui/helpers/responsive'
import { CLOUDINARY_ROOT_PATH } from '@farewill/ui/components/Image/constants'

const StyledP = styled(P)`
  ${screenMax.m`
    font-size: ${FONT.SIZE.M};
  `}
`

const Pledges = ({
  title,
  description,
  imagePath,
}: {
  title: string
  description: string
  imagePath: string
}): ReactElement => (
  <Grid margin={['L', 0]} marginFromL={['XXL', 0, 'XL']}>
    <Grid.Item spanFromL={8} spanFromXL={7}>
      <H tag="h2" size="L" maxWidth={660}>
        {title}
      </H>
      <StyledP size="L" maxWidthInColumns={6}>
        {description}
      </StyledP>
    </Grid.Item>
    <Grid.Item spanFromL={4} paddingFromL={['S', 0, 0]}>
      <Image
        path={imagePath}
        formatPath={({ path, ext }) => `${CLOUDINARY_ROOT_PATH}/${path}.${ext}`}
        ext="svg"
        width={250}
        widthFromL={400}
        stretch
      />
    </Grid.Item>
  </Grid>
)

export default Pledges
